<header class="flex flex-col w-full text-white md:hidden">
	<div class="pl-2 md:pl-6 pr-6 flex justify-between items-center bg-primary-180">
		<div class="flex items-center">
			<a href="/" class="block">
				<app-svg-asset name="gb-logo" class="size-auto hidden md:block ml-5" />
				<app-svg-asset name="gb-logo-small" class="w-16 h-16 md:hidden" />
			</a>
			<div class="text-base md:text-2xl font-bold border-l m-0 pl-5 border-l-white">
				{{ headerService.title() | translate }}
			</div>
		</div>

		@if (keycloakService.authenticated && headerService.allowSideMenu()) {
			<app-svg-asset
				name="icons/basic/hamburger-menu"
				class="size-6 cursor-pointer md:hidden"
				(click)="headerService.openMenu()"
			/>
		}
	</div>
</header>
